import React from 'react';

import { Navigation } from '@components/Navigation';
import { MembershipStatus } from '@components/settings/MembershipStatus';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { MetaHelper } from '@utils/pages';
import clsx from 'clsx';
import { useLocation } from 'react-router-dom';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    [theme.breakpoints.up('md')]: {
      padding: '1rem 2rem',
    },
    backgroundColor: theme.palette.background.paper,
    flexGrow: 1,
  },
  inner: {
    ...common.flexColumn,
    maxWidth: '1600px',
    padding: '1rem 1rem',
    margin: '0 auto',
  },
  contents: {
    ...common.flexInline,
    [theme.breakpoints.down('sm')]: {
      ...common.flexColumn,
    },
  },
  innerContent: {
    flex: 1,
  },
}));

export interface MembershipContainerProps {
  title?: string;
}

export const MembershipContainer: React.FC<React.PropsWithChildren<MembershipContainerProps>> = (
  props,
) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { children, title } = props;

  const { pathname } = useLocation();

  const displayTitle = title ?? MetaHelper.shared.getPageMeta(pathname)?.title ?? '';

  const pages = MetaHelper.shared.withPrefix('/settings/Membership');

  return (
    <div className={classes.container}>
      <div className={classes.inner}>
        <MembershipStatus />
        <div className={classes.contents}>
          <Navigation
            baseUrl="/settings/Membership"
            routes={pages
              .filter((p) => p.listed)
              .map((m) => ({
                name: m.name,
                label: m.title!,
                icon: <img src={m.icon} alt={m.title} height={16} width={16} />,
              }))}
          />

          <div className={classes.innerContent}>
            <div
              className={clsx(classes.textPrimary, classes.pageTitleText)}
              style={{ marginLeft: '2rem' }}
            >
              {displayTitle}
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
